<template>
  <f7-card class="elevation-3 padding-vertical-half padding-right">
    <f7-card-content>
      <!-- #905 · En oferta y pedido «Facturar como» y la orden de compra pasan al bloque «Condiciones de
           facturación» de abajo: dejarlos también aquí serían dos controles para lo mismo que pueden
           decir cosas distintas. En la factura, que no tiene ese bloque, siguen igual. -->
      <f7-list v-if="!condicionesDe" class="list-form" style="z-index: 40;">
        <ul>
          <f7-row no-gap class="col-100 display-flex" style="background-color: plum; border-radius: 5px; margin-left: 15px;">
            <div class="label-group col-100" style="margin-top: 0;margin-bottom: 0;">Facturación</div>
            <f7-col col="20" >
              <r-autocomplete
                outline
                ref="facturarComo"
                class="col-20"
                floating-label
                label="Facturar como"
                :form="rform"
                :dbItems="facturarComo"
                name="cliente.facturarComo"
                labelProp="nombre"
                idProp="valor"
              ></r-autocomplete>
            </f7-col>
            <f7-col col="20">
              <r-input
                floating-label
                label="Orden de Compra"
                :form="rform"
                type="check"
                name="ordenCompra"
                :readonly="readonly"
              ></r-input>
            </f7-col>
            <f7-col col="20">
              <r-input
                outline
                floating-label
                label="Nº Orden de Compra"
                :form="rform"
                type="text"
                name="numeroOrdenCompra"
                :readonly="readonly"
              ></r-input>
            </f7-col>
          </f7-row>
        </ul>
      </f7-list>
      <f7-list class="list-form" style="margin-top: 15px;">
        <ul>
          <f7-row>
            <r-autocomplete
              class="col-100 medium-33" 
              ref="viapago"
              :dbAdapter="ViaPago"
              floating-label
              label="Forma de pago"
              :form="rform"
              outline
              :shown-fields="['codigo', 'nombre', 'tipo', 'cuentaNecesaria', 'cuentaClienteNecesaria', 'plazoNecesario']" 
              :filter="{ filter: { activa: true, tipo: 'I' } }"
              name="cliente.viaPagoDefecto" 
              labelProp="nombre" 
              idProp="codigo"
              idFieldDetail="id"
              :readonly="readonly"
            ></r-autocomplete>
            <r-autocomplete
              v-show="viaPagoSeleccionado.cuentaNecesaria"
              class="col-100 medium-33" 
              :dbAdapter="CuentaBancaria"
              floating-label
              label="Cuenta de SIMECAL"
              :form="rform"
              outline
              :filter="{ filter: { activa: true} }"
              name="cliente.bancoPropio" 
              :shown-fields="['iban', 'nombre', 'swift']" 
              labelProp="nombre" 
              idFieldDetail="id"
              nameId="iban"
              :readonly="readonly"
            ></r-autocomplete>
            <r-autocomplete 
              v-show="viaPagoSeleccionado.cuentaClienteNecesaria"
              ref="cuentaCliente"
              class="col-100 medium-33" 
              floating-label
              outline
              label="Cuenta Cliente" 
              :form="rform" 
              :readonly="readonly"
              name="cliente.cuenta"
              :source="filterCondicionesCuentasClientes"
              :dbItems="cuentasCliente" 
              labelProp="iban"
              :nameId="'iban'"
              :idProp="null" 
            ></r-autocomplete>
            <r-autocomplete
              :dbAdapter="PlazoDias"
              class="col-100 medium-33" 
              floating-label
              label="Plazo días"
              :form="rform"
              name="cliente.plazoDias"
              labelProp="dias"
              idProp="dias"
              idFieldDetail="id"
              outline
              :source="filterPlazoDias"
              :filter="{ filter: { activa: true } }"
            ></r-autocomplete>
          </f7-row>
        </ul>
      </f7-list>
      <condiciones-facturacion
        v-if="condicionesDe"
        :rform="rform"
        :readonly="readonly"
        :documento="condicionesDe"
        @estado="$emit('estado-condiciones', $event)"
      ></condiciones-facturacion>
    </f7-card-content>
  </f7-card>
</template>

<script>
import Vue from "vue";
import rForm from "./rForm.vue";
import rInput from "./rInput.vue";
import rAutocomplete from "./rAutocomplete.vue";
import rAutocompleteM2m from "./rAutocompleteM2m.vue";
import CondicionPago from "../js/db/CondicionPago.js";
import ViaPago from "../js/db/ViaPago.js";
import PlazoDias from "../js/db/PlazoDias.js";
import Combos from "../js/db/Combos.js";
import Cliente from "../js/db/Cliente.js";
import CuentaBancaria from "../js/db/CuentaBancaria.js";
import condicionesFacturacion from "./condicionesFacturacion.vue";

export default {
  components: {
    Vue,
    rForm,
    rInput,
    rAutocomplete,
    rAutocompleteM2m,
    condicionesFacturacion,
  },
  data: function () {
    return {
      CondicionPago,
      ViaPago,
      PlazoDias,
      CuentaBancaria,
      viaPagoSeleccionada: null,
      condicionesPagoActivas: [],
      inicializado: false,
      yaBuscadasCondicionesPago: false,
      facturarComo: [],
      cuentasCliente: [],
    };
  },
  props: {
    rform: {},
    readonly: {
      type: Boolean,
      default: false
    },
    overrideReadonly: {
      type: Boolean,
      default: false
    },
    // 'OFERTA' o 'PEDIDO' para pintar el bloque «Condiciones de facturación» (#905); sin él, como antes.
    condicionesDe: {
      type: String,
      default: null
    },
  },
  methods: {
    filterCondicionesCuentasClientes: function (autocomplete) {
      const self = this;
      return function (query, render) {
        var options = self.cuentasCliente.map(cuenta => {
            if (cuenta["iban"] != undefined) {
              cuenta['txtValue'] = "" + cuenta["iban"].trim();
            }
            return cuenta;
          });
        var results = [];
        options.forEach(option => {
          if (!results.some(result => result.txtValue == option.txtValue) && option.txtValue) {
            results.push(option);
          }
        });

        render(results);
      };
    },
    filterPlazoDias: function (autocomplete) {
      return function (query, render) {
        const items = (autocomplete.preloaded ? autocomplete.items : autocomplete.initialItems) || [];
        const results = [];
        if (query.length >= autocomplete.minLength) {
          for (let i = 0; i < items.length; i++) {
            const value = items[i][autocomplete.searchProp];
            const txtValue = value === 0 || value ? value.toString() : '';
            if (
              txtValue &&
              txtValue.toLowerCase().indexOf(query.toLowerCase()) >= 0 &&
              autocomplete.showItem(items[i])
            ) {
              items[i].txtValue = txtValue;
              results.push(items[i]);
            }
          }
        }
        results.sort((a, b) => Number(a[autocomplete.searchProp] ?? 0) - Number(b[autocomplete.searchProp] ?? 0));
        render(results);
      };
    },
  },
  computed: {
    viaPagoSeleccionado: function() {
      // Obtener el ID guardado en el formData
      const viaPagoId = this.rform?.formData?.cliente?.viaPagoDefecto;
      if (!viaPagoId) return {};
      
      // Buscar en los items cargados del autocomplete
      if (this.$refs?.viapago?.items) {
        const found = this.$refs.viapago.items.find(item => item.codigo === viaPagoId);
        return found || {};
      }
      return {};
    },
    viaPagoStr: function() {
      const viaPago = this.viaPagoSeleccionado;
      return Object.keys(viaPago).length > 0 ? JSON.stringify(viaPago) : 'NO VIAPAGO';
    }
  },
  watch: {
    'rform.formData.cliente': {
      handler: function(newVal, oldVal) {
        const self = this;
        if (newVal && newVal.id) {
          Cliente.getCuentas({itemId: newVal.id}).then(res => {
            self.cuentasCliente = res.list;
          });
        }
      },
      deep: true
    }
  },
  created: function() {
    const self = this;
    var $ = self.$$;
    var $el = $(self.$el);
    var app = self.$f7;
    self.idData = self.id;
    Combos.getComboById("facturarComo").then(res => {
      self.facturarComo = res.list;
      if (self.$refs.facturarComo) {
        self.$refs.facturarComo.reload(self.facturarComo);
      }
    });
    if (self.rform.formData.cliente && self.rform.formData.cliente.id) {
      Cliente.getCuentas({ itemId: self.rform.formData.cliente.id }).then(res => {
        self.cuentasCliente = res.list;
      });
    }
  }
};
</script>